import { render, staticRenderFns } from "./assetsConfig.vue?vue&type=template&id=42eaaca0&"
import script from "./assetsConfig.vue?vue&type=script&lang=js&"
export * from "./assetsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports